import { createUseStyles } from "react-jss";
import { mediaQueries } from "../../../../../../common/constants";

export const SignupResumeDataPaymentStyle = createUseStyles((theme: any) => ({
  container: {
    padding: theme.paddings.default,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    [mediaQueries.TABLET]: {
      flexDirection: "column",
      alignItems: "center",
      rowGap: theme.gaps.sizes.base,
    },
  },
  oneItemRow: {
    paddingBottom: theme.paddings.default,
    width: "100%",

    "& > * ": {
      width: "100%",
    },
  },
  twoItemsRow: {
    display: "flex",
    paddingBottom: theme.paddings.default,
    width: "100%",
    [mediaQueries.TABLET]: {
      flexDirection: "column",
      rowGap: theme.gaps.sizes.base,
    },
    "& > * ": {
      width: "50%",
      [mediaQueries.TABLET]: {
        width: "100%",
      },
    },
  },
}));
